export default "<p>\n  <!-- profile-edit-user works! -->\n</p>\n"